import { render } from "./RiwayatView.vue?vue&type=template&id=00443636"
import script from "./RiwayatView.vue?vue&type=script&lang=js"
export * from "./RiwayatView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__